import React, { VFC } from 'react';

import { Icon } from 'components/tokens/Icon';
import { smileFace } from 'icons/default';
import { Colors } from 'enums/Colors';
import useMediaQuery from 'utils/useMediaQuery';

import styles from './SoldBy.module.scss';

interface ISoldBy {
  sellerName: string;
  municipality: string;
}

export const SoldBy: VFC<ISoldBy> = ({ sellerName, municipality }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <dl className={styles['dl-wrapper']}>
      <div className={styles['icon-wrapper']}>
        <Icon icon={smileFace} color={Colors.SkyBlue300} size={isMobile ? 18 : 28} />
      </div>
      <div>
        <dt className={styles.dt}>Bilen säljs av</dt>
        <dd className={styles.dd}>
          {sellerName} {municipality ? `i ${municipality}` : null}
        </dd>
      </div>
    </dl>
  );
};
